import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";
import { categories } from "@/mocks/siteData";
import SectionHeading from "@/components/feature/SectionHeading";
import Reveal from "@/components/base/Reveal";

const accentStyles: Record<string, string> = {
  primary: "bg-primary-100 text-primary-700",
  accent: "bg-accent-100 text-accent-900",
  secondary: "bg-secondary-100 text-secondary-900",
};

export default function CategoryGrid() {
  const countOf = (slug: string) => articles.filter((item) => item.categorySlug === slug).length;

  return (
    <section className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-100 border-y border-background-200">
      <SectionHeading
        eyebrow="Categories"
        title="按翻车类型浏览"
        desc="不同类型的翻车，暴露的是不同环节的问题。选一个你关心的方向，直接进分类看。"
        align="center"
      />

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
        {categories.map((cat, index) => (
          <Reveal key={cat.slug} delay={index * 50} className="h-full">
            <Link
              to={`/category?cat=${cat.slug}`}
              className="group flex flex-col h-full p-5 md:p-6 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors"
            >
              <div className="flex items-start justify-between gap-3">
                <span
                  className={`w-11 h-11 rounded-md flex items-center justify-center ${accentStyles[cat.accent] ?? accentStyles.primary}`}
                >
                  <i className={`${cat.icon} text-xl`}></i>
                </span>
                <span className="text-xs text-foreground-400">{countOf(cat.slug)} 篇整理</span>
              </div>
              <h3 className="mt-4 font-heading font-bold text-lg text-foreground-950 group-hover:text-primary-600 transition-colors">
                {cat.name}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600 flex-1">{cat.desc}</p>
              <span className="mt-4 inline-flex items-center gap-1 text-xs font-medium text-primary-600">
                进入分类
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
              </span>
            </Link>
          </Reveal>
        ))}
      </div>
    </section>
  );
}